module.exports = __webpack_public_path__ + "img/259.app_revealed.59796788.svg";